import TagList from './TagList'

export default TagList
